"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EUploadMimeType = void 0;
var EUploadMimeType;
(function (EUploadMimeType) {
    EUploadMimeType["Jpeg"] = "image/jpeg";
    EUploadMimeType["Mp4"] = "video/mp4";
    EUploadMimeType["Mov"] = "video/quicktime";
    EUploadMimeType["Gif"] = "image/gif";
    EUploadMimeType["Png"] = "image/png";
    EUploadMimeType["Srt"] = "text/plain";
    EUploadMimeType["Webp"] = "image/webp";
})(EUploadMimeType = exports.EUploadMimeType || (exports.EUploadMimeType = {}));
